import apiClient from '../client'
import type { PageResponse } from '../types'
import type { OperationLogResponse } from './types'

export const operationLogsApi = {
  list(params?: {
    userId?: number
    action?: number
    municipalityId?: number
    userName?: string
    keyword?: string
    dateFrom?: string
    dateTo?: string
    sortBy?: string
    order?: 'ASC' | 'DESC'
    page?: number
    size?: number
  }) {
    return apiClient.get<PageResponse<OperationLogResponse>>('/api/operation-logs', { params })
  },

  exportCsv(params?: {
    userId?: number
    action?: number
    municipalityId?: number
    userName?: string
    keyword?: string
    dateFrom?: string
    dateTo?: string
  }) {
    return apiClient.get('/api/operation-logs/export', {
      params,
      responseType: 'blob',
    })
  },
}
